import AddIcon from "@mui/icons-material/Add";
import { Box, Button, TableCell, TableRow, Typography } from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

interface EmptyFormulaProps {
  onCreateFormula: () => void;
  readOnly?: boolean;
}

function EmptyFormula({
  onCreateFormula,
  readOnly = false,
}: EmptyFormulaProps) {
  const { colors } = useCelleraTheme();
  return (
    <TableRow>
      <TableCell colSpan={5} sx={{ border: "none" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "450px",
            gap: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: colors.text.primary,
              fontWeight: 600,
              fontSize: "1rem",
            }}
          >
            No items added yet
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: colors.text.secondary,
              fontSize: "0.875rem",
            }}
          >
            {readOnly
              ? "No formulas found in this prescription."
              : "Add at least one item to begin creating a prescription."}
          </Typography>
          {!readOnly && (
            <Button
              variant="text"
              startIcon={<AddIcon />}
              onClick={onCreateFormula}
              sx={{
                color: colors.secondary.main,
                textTransform: "none",
                fontWeight: 500,
                mt: 1,
              }}
            >
              Add New Item
            </Button>
          )}
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default EmptyFormula;
